import { Id } from "@dgs/core";

export enum ApplicationFilterType {
	PARTICIPANT_MANAGEMENT = "PARTICIPANT_MANAGEMENT",
	DEEP = "DEEP",
	APP = "APP",
	DEEP_APP = "DEEP_APP",
	KRONOS = "KRONOS",
	CAR_FLEET = "CAR_FLEET",
	MAILCOACH = "MAILCOACH",
}

export enum ApplicationType {
	PARTICIPANT_MANAGEMENT = "PARTICIPANT_MANAGEMENT",
	DEEP = "DEEP",
	KRONOS = "KRONOS",
	CAR_FLEET = "CAR_FLEET",
	MAILCOACH = "MAILCOACH",
}

interface ApplicationBaseResource {
	id: Id;
	type: ApplicationType;
	projectNumber: string;
	subdomain: string;
	setupDate: string;
	deletionDate: string;
}

export interface ApplicationFilterTypeOption {
	label: string;
	filterType: ApplicationFilterType;
}

export interface ApplicationDetailResource extends ApplicationBaseResource {
	domainData: DomainData;
	configuration: Record<string, any>;
}

export type DomainData = ParticipantManagerDomainData | DeepKronosDomainData | CarFleetMailcoachDomainData;
export interface ParticipantManagerDomainData {
	frontendUrl: string;
	adminUrl: string;
	nominationManagerUrl: string;
}

export interface DeepKronosDomainData {
	frontendUrl: string;
	adminUrl: string;
	nominationManagerUrl?: undefined;
}

export interface CarFleetMailcoachDomainData {
	frontendUrl?: undefined;
	adminUrl: string;
	nominationManagerUrl?: undefined;
}
export interface ApplicationIndexResource extends ApplicationBaseResource {
	id: Id;
}
